import {
  createListAllQuery,
  getRecipe,
  GetRecipeQuery,
  GetRecipeQueryVariables,
  graphqlCall,
  listRecipes,
  ListRecipesQuery,
  ListRecipesQueryVariables,
  Recipe,
} from '@akin-home/amplify';
import { recipeGraphqlToModel } from '../functions';

export const listRecipesQuery = (params?: ListRecipesQueryVariables) =>
  graphqlCall<ListRecipesQuery>(listRecipes, params);

export const listAllRecipesQuery = createListAllQuery<
  Recipe,
  ListRecipesQueryVariables
>(listRecipes, 'listRecipes');

export const listAllRecipeModels = async (
  params: ListRecipesQueryVariables
) => {
  return (await listAllRecipesQuery(params)).map(recipeGraphqlToModel);
};

export const getRecipeQuery = (params: GetRecipeQueryVariables) =>
  graphqlCall<GetRecipeQuery>(getRecipe, params);
